import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from 'axios';

const hostDev = "dev.g-eoc.com"
const hostProd = "g-eoc.com"

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'reverb',
    // key: 'zmf6ormkbptkeraxikbp',
    // wsHost: "disaster-backend.gentechsoft.tech",
    key: 'wge3dhvicpuiu9ehlefz',
    wsHost: hostDev,
    // dev.g-eoc.com
    // g-eoc.com

    wsPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    encrypted: false,
    enabledTransports: ['ws'],
    disableStats: true,

    authorizer: (channel) => {
        return {
            authorize: (socketId, callback) => {
                axios.post("/broadcasting/auth", {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                    .then((response) => {
                        callback(false, response.data);
                    })
                    .catch((error) => {
                        console.debug("error: ", +error.data);
                        callback(false, error);
                    });
            },
        };
    },
});